import React from 'react';
import CheckBoxFilter from './CheckBoxFilter';

const CATEGORY_ID = [6];

export default function BenefitsCoverageFilter({ useStagingMode = false, onStageChange = null }) {
  return (
    <CheckBoxFilter
        matchIds={CATEGORY_ID}
        title="Benefícios do seguro"
        ariaLabel="Benefícios do seguro"
        initialVisibleCount={5}
        showAllLabel="Ver todos os benefícios"
        useStagingMode={useStagingMode}
        onStageChange={onStageChange}
    />
  );
}



// WEBPACK FOOTER //
// ./src/views/v2/search/components/filter/components/BenefitsCoverageFilter.jsx